import { AxiosInstance, AxiosRequestConfig } from 'axios'

import { UserBookingMethodsRepository } from './domain/UserBookingMethodsRepository'

import { BookingMethods } from '../../contracts/appointment/bookingMethods'
import { AxiosErrorHandler } from '../../foundation'

export class UserApiBookingMethods implements UserBookingMethodsRepository {
  private errorHandler: AxiosErrorHandler

  constructor(private axios: AxiosInstance) {
    this.errorHandler = new AxiosErrorHandler()
  }

  getById = async (id: number): Promise<BookingMethods> => {
    const config: AxiosRequestConfig<{ id: number }> = {
      url: `/appointments/booking-methods/service-offers/${id}`,
      method: 'get',
    }

    try {
      const { data } = await this.axios.request<BookingMethods>(config)
      return data
    } catch (error) {
      return this.errorHandler.handle(error)
    }
  }
}
